import type { SignalHash } from '../utils';
import type { Entity } from './Entity';

export interface Component<D = any> {
  readonly id?: number;
  readonly dynamic?: boolean;
  readonly name?: string;
  signals?: SignalHash;
  /** reference to the entity the component is attached too which is automatically injected */
  entity?: Entity<any, any, any>;

  /** called when the entity it is added too is removed from the pool */
  init?: (data: D) => void;
  /** called when the entity it is added too is added back to the pool */
  reset?: () => void;
  /** called when scene is destroyed */
  destroy?: () => void;
}

export interface ComponentClass<
  D = any,
  C extends Component<D> = Component<D>,
> {
  NAME: string;
  ID?: number;
  new (): C;
}

/**
 * A helper function that creates a component class that can be used as a tag.
 * @param name - name of the tag
 * @returns An empty component with the given name used as a tag
 */
export function DefineTag(name: string): ComponentClass<{}> {
  return class implements Component {
    public static readonly NAME = name;
  };
}

export function odieDestroyComponent(component: Component) {
  if (!component) return;

  if (component.signals) {
    const signals = component.signals;

    for (const i in signals) {
      signals[i].disconnectAll();
    }
  }
  component.signals = undefined;
  component.entity = undefined;
  component.reset?.();
}
